import { render } from "./GoogleButton.vue?vue&type=template&id=4dca7766&scoped=true"
const script = {}

import "./GoogleButton.vue?vue&type=style&index=0&id=4dca7766&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dca7766"]])

export default __exports__